import React from "react"
import {FieldManagementPreviewProps} from "../../../../render/management-preview";


export default function FieldReaction_ManagementPreview(props: FieldManagementPreviewProps) {

    // const model : any = {}
    // model[props.field.fieldId] = "Lorem Ipsum"

    // return <FieldView field={props.field} model={model} />



    return (
        <div className="ui5-reactions">
            <div className="reaction-view my-reaction">
                <div className="reaction-emoji">👍</div>
                <div className="reaction-count">5</div>
            </div>
            <div className="reaction-view my-reaction">
                <div className="reaction-emoji">🔥</div>
                <div className="reaction-count">1</div>
            </div>
        </div>
    )

}